import { SECTION_IDS } from "../constants/sections";
import { ABOUT_STRINGS } from "../constants/strings";

function AboutSection() {
  return (
    <section id={SECTION_IDS.about} className="section about-section">
      <div className="section-inner split-layout">
        <div>
          <p className="eyebrow">{ABOUT_STRINGS.eyebrow}</p>
          <h2>{ABOUT_STRINGS.heading}</h2>
          {ABOUT_STRINGS.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <div
          className="highlight-panel"
          aria-label={ABOUT_STRINGS.highlightsAriaLabel}
        >
          {ABOUT_STRINGS.highlights.map((item) => (
            <div className="highlight-item" key={item}>
              <span aria-hidden="true">✓</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
